export default __webpack_public_path__ + "static/champion-htf-bantamweight-webfont-9406d46a00ae63ea6f4e8d01f0c8da7a.ttf";